import React, { type ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { env } from 'shared/config';

const isProdEnv = env === 'release';

const capitalize = (s: string) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export type PageProps = {
  title: string;
  children?: ReactNode;
};

export const Page: React.FC<PageProps> = ({ children, title }) => {
  const formattedTitle = title ? `${capitalize(title)} - Scoopr` : 'Scoopr';

  return (
    <>
      <Helmet>
        {!isProdEnv ? <meta name="robots" content="noindex" /> : null}
        <title>{formattedTitle}</title>
      </Helmet>
      {children}
    </>
  );
};

export default Page;
